import { Link } from "react-router-dom"

// material-ui
import { Grid, Stack, Typography } from "@mui/material"

// importation du projet
import AuthWrapper from "./AuthWrapper"
import AuthResetPassword from "./auth-forms/AuthResetPassword"
import i18n from "i18n"

// ================================|| CONNEXION ||================================ //

const ResetPassword = () => (
  <AuthWrapper>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="baseline"
          sx={{ mb: { xs: -0.5, sm: 0.5 } }}
        >
          <Typography variant="h3">{i18n.t("reset-password")}</Typography>
          <Typography
            component={Link}
            to="/auth/login"
            variant="body1"
            sx={{ textDecoration: "none" }}
            color="primary"
          >
            {i18n.t("login")}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <AuthResetPassword />
      </Grid>
    </Grid>
  </AuthWrapper>
)

export default ResetPassword
